import { debounce, DebounceSettings } from "lodash";
import Vue, { ComponentOptions } from "vue";
import { createDecorator, VueDecorator } from "vue-class-component";

export function Debounce(
  wait?: number,
  options?: DebounceSettings
): VueDecorator {
  return createDecorator(
    (componentOptions: ComponentOptions<Vue>, k: string) => {
      const fn = (componentOptions.methods || (componentOptions.methods = {}))[
        k
      ];
      componentOptions.methods[k] = debounce(
        function (this: any) {
          fn.apply(this, [...arguments]);
        },
        wait,
        options
      );
    }
  );
}
